<template>
    <div class="container pt-2">
        <PageTitle main="Propostas" sub="Propostas recebidas pela empresa" />
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group>
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        class="textInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button variant="outline-secondary" class="botaoInput" :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-propostas" 
                class="text-center table table-sm" 
                :items="propostas.length>0?propostas:[]" 
                :fields="fields" 
                per-page="5"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="success" class="mr-2 btn-sm mb-1 btn-size" @click="openModal(data.item)">
                        <i class="fas fa-envelope-open-text"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="5"
                aria-controls="table-propostas"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group>
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        class="textInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button variant="outline-secondary" class="botaoInput" :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-propostas" 
                class="text-center table table-sm" 
                :items="propostas.length>0?propostas:[]" 
                :fields="fields" 
                per-page="5"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="success" class="mr-2 btn-sm mb-1 btn-size" @click="openModal(data.item)">
                        <i class="fas fa-envelope-open-text"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="5"
                aria-controls="table-propostas"
                first-number
                last-number
                align="center"
                >
                </b-pagination>
            </div>
        </div>
        <!-- MODAL PROPOSTA -->
        <b-modal id="modal-proposta" hide-footer>
            <template v-slot:modal-title>
                Dados do Transporte: {{ proposta.orcamento_codigo }}
            </template>
            <p>Origem: {{ proposta.orcamento_origem_cep }} - {{ proposta.orcamento_origem }}</p>
            <p>Destino: {{ proposta.orcamento_destino_cep }} - {{ proposta.orcamento_destino }}</p>
            <hr>
            <p>Tipo de Carga: {{ proposta.orcamento_carga_titulo }}</p>
            <p v-if="proposta.orcamento_caminhao!=='0' && proposta.orcamento_caminhao!==undefined">Tipo de Caminhão: {{ proposta.orcamento_caminhao_titulo }}</p>
            <p v-else>Tipo de Caminhão: Não há especificação para este item!</p>
            <hr>
            <p v-if="proposta.orcamento_data_inicio!=='0000-00-00' && proposta.orcamento_data_inicio!==undefined">Previsão de Envio: {{ formatData(proposta.orcamento_data_inicio) }}</p>
            <p v-else>Previsão de Envio: Não há especificação para este item!</p>
            <p v-if="proposta.orcamento_data_final!=='0000-00-00' && proposta.orcamento_data_final!==undefined">Previsão de Entrega: {{ formatData(proposta.orcamento_data_final) }}</p>
            <p v-else>Previsão de Entrega: Não há especificação para este item!</p>
            <hr>
            <p>Valor da Proposta: {{ proposta.proposta_valor }}</p>
            <p v-if="proposta.orcamento_data_final!=='0000-00-00' && proposta.orcamento_data_final!==undefined">Data da Proposta: {{ formatData(proposta.proposta_data) }}</p>
            <p v-else>Exibição da data não válida!</p>
            <hr>
            <p>Elaborado por: {{ proposta.funcionario_nome }} - {{ proposta.funcionario_email }}</p>
            
            <div class="row">
                <div class="col-md-12">
                    <b-button variant="success" block class="mt-3 botaoInput" @click="aceitaProposta">Aceitar Proposta</b-button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <b-button variant="danger" block class="mt-3 botaoInput" @click="rejeitaProposta">Rejeitar Proposta</b-button>
                </div>
            </div>
        </b-modal>
        <!-- MODAL PAGAMENTO -->
        <b-modal id="modal-pagamento" hide-footer>
            <template v-slot:modal-title>
                Pagamento do Transporte: {{ proposta.orcamento_codigo }}
            </template>
            <b-form @submit.prevent="onBuyProduct">
                <div class="row">
                    <div class="col-md-12">
                        <b-form-group label="Forma de Pagamento:" label-for="pagamento-forma">
                            <b-form-select id="pagamento-forma" :options="formas" v-model="formaPagamento"/>
                        </b-form-group>
                    </div>
                </div>
                <hr>
                <div class="row" v-if="formaPagamento==='creditCard'">
                    <div class="col-md-12">
                        <b-form-group label="Número do Cartão:" label-for="pagamento-cartao">
                            <b-form-input id="pagamento-cartao" type="tel"
                                v-model="cartao.numero"/>
                        </b-form-group>
                    </div>
                </div>
                <div class="row" v-if="formaPagamento==='creditCard'">
                    <div class="col-md-12">
                        <b-form-group label="Número de Parcelas:" label-for="pagamento-parcelas">
                            <b-form-select id="pagamento-parcelas" :options="parcelas" v-model="cartao.parcelas"/>
                        </b-form-group>
                    </div>
                </div>
                <div class="row" v-if="formaPagamento==='creditCard'">
                    <div class="col-md-4">
                        <b-form-group label="Mês da Validade:" label-for="pagamento-mes">
                            <b-form-select id="pagamento-mes" :options="meses" v-model="cartao.mes"/>
                        </b-form-group>
                    </div>
                    <div class="col-md-4">
                        <b-form-group label="Ano da Validade:" label-for="pagamento-ano">
                            <b-form-input id="pagamento-ano" type="number" min="2020"
                                v-model="cartao.ano"/>
                        </b-form-group>
                    </div>
                    <div class="col-md-4">
                        <b-form-group label="CVV:" label-for="pagamento-cvv">
                            <b-form-input id="pagamento-cvv" type="tel"
                            v-mask="['###', '####']"
                            v-model="cartao.cvv"/>
                        </b-form-group>
                    </div>
                </div>
                <hr v-if="formaPagamento==='creditCard'">
                <div class="row" v-if="formaPagamento==='creditCard'">
                    <div class="col-md-12">
                        <b-form-group label="Nome do Titular:" label-for="pagamento-nomeTitular">
                            <b-form-input id="pagamento-nomeTitular" type="text"
                                v-model="cartao.titular"
                                placeholder="Digite o nome do Titular do Cartão"
                                @blur="geraHash"/>
                        </b-form-group>
                    </div>
                </div>
                <div class="row" v-if="formaPagamento==='creditCard'">
                    <div class="col-md-12">
                        <b-form-group label="CPF do Titular:" label-for="pagamento-cpfTitular">
                            <b-form-input id="pagamento-cpfTitular" type="tel"
                                v-model="cartao.cpf"
                                placeholder="Digite o CPF do Titular do Cartão"/>
                        </b-form-group>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <b-button variant="success" block class="mt-3 botaoInput" @click="setPagar">Pagar</b-button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <b-button variant="danger" block class="mt-3 botaoInput" @click="cancelaPagamento">Cancelar</b-button>
                    </div>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>

import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { VueEasyJwt } from 'vue-easy-jwt'
import { VMoney } from 'v-money'
import { mask } from 'vue-the-mask'
import pagarme from 'pagarme'

export default {
    name: 'propostas',
    components: { PageTitle },
    directives: { money: VMoney, mask },
    data: function() {
        return {
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            jwt: new VueEasyJwt(),
            proposta: {},
            propostas: [],
            fields: [
                { key: 'orcamento_codigo', label: 'Código', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'orcamento_origem', label: 'Origem', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'orcamento_destino', label: 'Destino', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'actions', label: 'Ações', thClass: 'tituloTabela', tdClass: 'actionsTabela' }
            ],
            larguraTela: 0,
            overflowValue: 'auto',
            level: '',
            quemRecebeu: '',
            cliente: {},
            nome: '',
            email: '',
            dados: {},
            formas: [
                { value: 'boleto', text: 'Boleto' },
                { value: 'creditCard', text: 'Cartão de Crédito' }
            ],
            meses: [
                { value: '1', text: 'Janeiro' },
                { value: '2', text: 'Fevereiro' },
                { value: '3', text: 'Março' },
                { value: '4', text: 'Abril' },
                { value: '5', text: 'Maio' },
                { value: '6', text: 'Junho' },
                { value: '7', text: 'Julho' },
                { value: '8', text: 'Agosto' },
                { value: '9', text: 'Setembro' },
                { value: '10', text: 'Outubro' },
                { value: '11', text: 'Novembro' },
                { value: '12', text: 'Dezembro' }
            ],
            parcelas: [
                { value: 1, text: '1 Parcela'},
                { value: 2, text: '2 Parcelas'},
                { value: 3, text: '3 Parcelas'},
                { value: 4, text: '4 Parcelas'},
                { value: 5, text: '5 Parcelas'},
                { value: 6, text: '6 Parcelas'},
                { value: 7, text: '7 Parcelas'},
                { value: 8, text: '8 Parcelas'},
                { value: 9, text: '9 Parcelas'},
                { value: 10, text: '10 Parcelas'},
                { value: 11, text: '11 Parcelas'},
                { value: 12, text: '12 Parcelas'}
            ],
            formaPagamento: '',
            cartao: {},
            hashCartao: '',
            produtos: [],
            cliente_id: '',
            pagamento: {}
        }
    },
    computed: {
        rows() {
            return this.propostas.length
        }
    },
    methods: {
        setPagar() {
            if(this.formaPagamento==='creditCard'){
                this.payWithCard()
            }else if(this.formaPagamento==='boleto'){
                this.payWithBoleto()
            }
            this.cancelaPagamento()
        },
        cancelaPagamento() {
            this.$bvModal.hide('modal-proposta')
            this.$bvModal.hide('modal-pagamento')
            this.proposta = {}
            this.pagamento = {}
        },
        formatData(data) {
            const arr = data.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        openModal(item){
            this.proposta = item
            this.$bvModal.show('modal-proposta')
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        aceitaProposta() {
            // this.produtos.push({
            //     id: 1,
            //     Descricao: "Transporte código: " + this.proposta.orcamento_codigo,
            //     Valor: this.proposta.proposta_valor,
            //     Quantidade: 1
            // })
            this.$bvModal.hide('modal-proposta')
            this.$bvModal.show('modal-pagamento')
            this.searchCep()
            // this.setSession()
        },
        rejeitaProposta() {
            this.dados.orcamento = this.proposta.orcamento_id
            axios['post'](`${baseApiUrl}/backend/rejeitaProposta.php`, this.dados)
            .then(() => {
                // const tipo = `?tipo=novoorcamento`
                // const destinoEmail = `&destinoEmail=${this.email}`
                // const destinoNome = `&destinoNome=${this.nome}`
                // axios.get(`${baseApiUrl}/backend/mailorcamento.php${tipo}${destinoEmail}${destinoNome}`).then({})

                this.$toasted.global.defaultSuccess({ message : 'orcamento rejeitado com sucesso!' })
                this.reset()
                this.$bvModal.hide('modal-proposta')
            })
            .catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })
        },
        loadPropostas() {
            const url = `${baseApiUrl}/backend/propostasAbertas.php?cliente=${this.quemRecebeu}`
            axios.get(url).then(res => {
                this.propostas = res.data
                if(this.propostas.length > 0) {
                    this.exibeRodape = false
                }else{
                    this.exibeRodape = true
                }
            })
        },
        loadCliente() {
            const url = `${baseApiUrl}/backend/clientes.php?id=${this.quemRecebeu}`
            axios.get(url).then(res => {
                this.cliente = res.data[0]
                this.cliente.ddd = this.cliente.telefone.substr(1,2)
                const tel1 = this.cliente.telefone.substr(4,5)
                const tel2 = this.cliente.telefone.substr(10)
                this.cliente.tel = tel1 + tel2
                this.cliente.cpf = '39373972804'
            })
        },
        searchCep () {
            axios.get(`https://viacep.com.br/ws/${ this.cliente.cep }/json/`)
            .then( res => {
                this.cliente.bairro = res.data.bairro
            })
            .catch( error => console.log(error) )
		},
        reset() {
            this.proposta = {}
            this.loadPropostas()
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
                this.nome = decodedToken['data'].nome
                this.email = decodedToken['data'].email
                this.cliente_id = decodedToken['data'].cliente_id
            }
        },
        geraHash() {
            const exp = this.cartao.mes + '' + this.cartao.ano
            const card = {
                card_number: this.cartao.numero,
                card_holder_name: this.cartao.titular,
                card_expiration_date: exp,
                card_cvv: this.cartao.cvv,
            }
            
            pagarme.client.connect({ encryption_key: 'ek_test_yfd33ywsApRWDXsVCe1dEf4zUoNRXE' })
            .then(client => client.security.encrypt(card))
            .then(card_hash => this.hashCartao=card_hash)

            console.log(this.hashCartao)
        },
        payWithCard() {
            this.geraHash()
            const valor = this.proposta.proposta_valor
            const valor1 = valor.substr(3)
            if(valor1.indexOf(".") !== -1) {
                const valor2 = valor1.split(".")
                const valor3 = valor2[0] + '' + valor2[1]
                const valor4 = parseFloat(valor3.replace(',', '.'))
                this.proposta.valorReal = valor4*100
            }else{
                const valor2 = valor1
                const valor3 = valor2[0] + '' + valor2[1]
                const valor4 = parseFloat(valor3.replace(',', '.'))
                this.proposta.valorReal = valor4*100
                
            }

            this.pagamento.valor = this.proposta.valorReal
            this.pagamento.hash = this.hashCartao
            this.pagamento.cliente = this.cliente_id
            this.pagamento.codigo = this.proposta.orcamento_codigo
            this.pagamento.modo = 'creditCard'
            this.pagamento.installments = this.cartao.parcelas
            this.pagamento.orcamento = this.proposta.orcamento_id

            axios['post'](`${baseApiUrl}/backend/payment.php`, this.pagamento)
            .then(() => {
                // const tipo = `?tipo=novoorcamento`
                // const destinoEmail = `&destinoEmail=${this.email}`
                // const destinoNome = `&destinoNome=${this.nome}`
                // axios.get(`${baseApiUrl}/backend/mailorcamento.php${tipo}${destinoEmail}${destinoNome}`).then({})

                this.$toasted.global.defaultSuccess({ message : 'Pagamento realizado com sucesso!' })
                this.reset()
                this.$bvModal.hide('modal-proposta')
            })
            .catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })

        },
        payWithBoleto() {
            const valor = this.proposta.proposta_valor
            const valor1 = valor.substr(3)
            if(valor1.indexOf(".") !== -1) {
                const valor2 = valor1.split(".")
                const valor3 = valor2[0] + '' + valor2[1]
                const valor4 = parseFloat(valor3.replace(',', '.'))
                this.proposta.valorReal = valor4*100
            }else{
                const valor2 = valor1
                const valor3 = valor2[0] + '' + valor2[1]
                const valor4 = parseFloat(valor3.replace(',', '.'))
                this.proposta.valorReal = valor4*100
                
            }

            this.pagamento.valor = this.proposta.valorReal
            this.pagamento.cliente = this.cliente_id
            this.pagamento.codigo = this.proposta.orcamento_codigo
            this.pagamento.modo = 'boleto'
            this.pagamento.orcamento = this.proposta.orcamento_id

            console.log(this.pagamento.valor)
            console.log(this.pagamento.cliente)
            console.log(this.pagamento.codigo)
            console.log(this.pagamento.modo)

            axios['post'](`${baseApiUrl}/backend/payment.php`, this.pagamento)
            .then(() => {
                // const tipo = `?tipo=novoorcamento`
                // const destinoEmail = `&destinoEmail=${this.email}`
                // const destinoNome = `&destinoNome=${this.nome}`
                // axios.get(`${baseApiUrl}/backend/mailorcamento.php${tipo}${destinoEmail}${destinoNome}`).then({})

                this.$toasted.global.defaultSuccess({ message : 'Pagamento realizado com sucesso!' })
                this.reset()
                this.$bvModal.hide('modal-proposta')
            })
            .catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })

        }

    },
    mounted() {
        this.validaLogin()
        if (this.level !== 'cliente') {
            this.$router.push('/')
        }
        this.loadPropostas()
        this.loadCliente()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.propostas.length

        // pagarme.client.connect({ api_key: 'ak_test_U5a2eVXEbb3cwyAuhJRyZoNcRZyvrT' })
        //     .then(client => client.transactions.all())
        //     .then(transactions => console.log(transactions))

    }
}
</script>

<style>
    
</style>